import React, { useState, useEffect, useCallback } from 'react';

import { producaov2 } from '../../../../../services/apis';
import { useRouter } from '../../../../../hooks/router';

export const ACCESS_BLOCKINGS_FILTERS = {
  USER: 'user',
  REASONID: 'reasonID',
  COURSE: 'course'
}

export default function useAccessBlockings() {
  const [accessBlockings, setAccessBlockings] = useState({
    data: null,
    paging: null,
  });
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({});

  const route = useRouter();

  const loadAccessBlockings = useCallback(async ({ page = 1, limit = 50, filters }) => {
    setLoading(true);

    try {
      const response = await producaov2.get(`/admin/access-blocking`, {
        params: {
          page,
          limit,
          ...(filters?.[ACCESS_BLOCKINGS_FILTERS.USER] && {user: filters[ACCESS_BLOCKINGS_FILTERS.USER]}),
          ...(filters?.[ACCESS_BLOCKINGS_FILTERS.COURSE] && {course: filters[ACCESS_BLOCKINGS_FILTERS.COURSE]}),
          ...(filters?.[ACCESS_BLOCKINGS_FILTERS.REASONID] && {reasonID: filters[ACCESS_BLOCKINGS_FILTERS.REASONID]})
        }
      });

      setAccessBlockings(response.data);
    } catch(error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if(route.query?.id_pessoa && Object.values(filters).length === 0) {
      onSubmitFilters({
        [ACCESS_BLOCKINGS_FILTERS.USER]: route.query.id_pessoa
      });

      return;
    }

    if(!accessBlockings.data) {
      loadAccessBlockings({ page, limit });
    }
  }, [route]);

  const nextPage = () => {
    setPage(prev => prev + 1);
  }

  const prevPage = () => {
    setPage(prev => prev - 1);
  }

  const changePage = (page) => {
    loadAccessBlockings({ page, limit, filters });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setPage(page);
  }

  const changeLimit = (limit) => {
    loadAccessBlockings({ page: 1, limit, filters });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setLimit(limit);
    setPage(1);
  }

  const refreshData = () => {
    loadAccessBlockings({ page, limit, filters });
  }

  const onSubmitFilters = (filters) => {
    loadAccessBlockings({ page, limit, filters });
    setFilters(filters);
  }

  const onClearFilters = () => {
    loadAccessBlockings({ page, limit, filters: {} });
    setFilters({});
  }

  return {
    accessBlockings,
    loading,
    limit,
    page,
    filters,
    changeLimit,
    prevPage,
    nextPage,
    changePage,
    refreshData,
    onSubmitFilters,
    onClearFilters
  }
}